import { useFadeIn } from '@/hooks/useFadeIn';

const concerns = [
  '昔から前歯の白い点が気になっている',
  '写真を見るたびに気になってしまう',
  'ホワイトニングしても変わらなかった',
  '人前で思い切り笑えない',
  '歯は削りたくない',
  '治らないものだと思っていた',
  'セラミック以外の方法を探している',
  '自然な見た目に改善したい',
];

export default function IconConcerns() {
  const heading = useFadeIn({ direction: 'up' });
  const imgFade = useFadeIn({ direction: 'up', delay: 100 });
  const listFade = useFadeIn({ direction: 'up', delay: 200 });

  return (
    <section className="py-14 md:py-20" style={{ backgroundColor: '#F3F6FA' }}>
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div ref={heading.ref} style={heading.style} className="text-center mb-10 md:mb-16">
          <h2 className="font-serif text-gray-900 text-2xl md:text-3xl leading-relaxed">
            ホワイトスポットで、<br />
            こんなお悩みありませんか?
          </h2>
          <p className="font-light text-gray-500 text-sm md:text-base mt-5 leading-relaxed max-w-xl mx-auto">
            人には気づかれなくても、自分ではずっと気になってしまう。<br className="hidden md:block" />
            そんなお悩みを抱えていませんか?
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-stretch">
          {/* 左：女性画像 */}
          <div ref={imgFade.ref} style={imgFade.style} className="w-full lg:w-1/2">
            <div className="relative rounded-lg overflow-hidden w-full h-full min-h-[360px] md:min-h-[480px]">
              <img
                alt="口元を気にする若い女性"
                className="w-full h-full object-cover object-top"
                src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/758903bf2fbfaa32e1492687ed91d069.png"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent"></div>
            </div>
          </div>

          {/* 右：チェックリスト */}
          <div ref={listFade.ref} style={listFade.style} className="w-full lg:w-1/2">
            <div className="bg-white rounded-lg p-6 md:p-10 h-full flex flex-col justify-center">
              <ul className="space-y-4 md:space-y-5">
                {concerns.map((text) => (
                  <li key={text} className="flex items-start gap-3 md:gap-4">
                    <div
                      className="shrink-0 w-6 h-6 md:w-7 md:h-7 rounded flex items-center justify-center border-2"
                      style={{ borderColor: '#CBD5E0' }}
                    >
                      <i className="ri-check-line text-white text-sm md:text-base opacity-0"></i>
                    </div>
                    <span className="font-light text-gray-700 text-sm md:text-base leading-relaxed pt-0.5">
                      {text}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-gray-200">
                <p className="font-light text-gray-900 text-sm md:text-base leading-relaxed text-center">
                  ひとつでも当てはまる方は、<br className="hidden md:block" />
                  <span style={{ color: '#3E5F8F' }} className="font-normal">ICON治療</span>で改善できる可能性があります。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}